import {twoArrayHaveSameElement} from "@app/utils/CommonUtils";
import {CommonUseFields, ResponseCode} from "@app/constants/Common";
import * as CommonUtils from "@app/utils/CommonUtils";
import * as EmailUtils from "@app/utils/EmailUtils";
import {Messages, showMessage} from "@app/constants/Messages";
import {requestFetchDicts} from "@app/services/ExtractService";
import {requestSubmitPriorityInputNotes} from "@app/services/UserService";
import {toast} from "react-toastify";

export const checkExistsCommonFieldValues = (candidate={}, userLoginId) => {
    const fields = (candidate.fields && candidate.fields.length > 0) ? candidate.fields : Object.keys(candidate)
    if (fields && fields.length > 0) {
        for (let i=0; i < fields.length; i++) {
            const f = fields[i]
            const commonField = CommonUseFields[f]
            if (commonField && !commonField.notUnique) {
                const parentField = commonField.parent
                const otherInputs = candidate[parentField]
                let arrOtherUserInputs = []
                if (otherInputs) {
                    otherInputs.forEach(oin => {
                        // Check xem nếu có thông tin đã đc nhập trong pm và là của user khác user đang login.
                        if (oin[f] && oin.created_user !== userLoginId) {
                            arrOtherUserInputs = [...arrOtherUserInputs, ...CommonUtils.toArray(oin[f])]
                        }
                    })
                    if (twoArrayHaveSameElement(CommonUtils.toArray(candidate[f]), arrOtherUserInputs)) {
                        showMessage(`Dữ liệu ${commonField.title} trùng với dữ liệu đã được nhập bởi user khác.`)
                        return true
                    }
                }
            }
        }
    }
    return false
}

export const processWithoutPersonalEmail = async (emails) => {
    const resPersonalEmails = await requestFetchDicts('personal_email');
    const standardPersonalEmails = resPersonalEmails.content ? resPersonalEmails.content.split("\n") : []
    if (standardPersonalEmails.length > 0 && !EmailUtils.validatePersonalEmails(emails, standardPersonalEmails)) {
        if (window.confirm(Messages.confirmNextProcessWithNotPersonalEmail) === false) {
            return false
        }
    }
    return true
}


export const confirmSubmitNotesWhenInputInPriorityTimeRange = (priorityNotifyId) => {
    let priorityConfirm = prompt(Messages.inputInPriorityTimeRange, "");
    if (priorityConfirm) {
        //Gửi thông tin note về ứng viên trong thời gian NL ưu tiên
        let requestBody = {
            notes: priorityConfirm,
            notify_id: priorityNotifyId,
        }
        requestSubmitPriorityInputNotes(requestBody).then(res1 => {
            if (res1.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Submit thông tin Notes ứng viên thành công.`);
            } else {
                toast.error(`Submit thông tin Notes ứng viên thất bại.`);
            }
        });
    }
}